import React from "react"

import { Anchor } from "~components/Markdown"
import { FiChevronRight } from "react-icons/fi"

import * as style from "./CTA.module.scss"

const CTA = ({ to, children }) => (
  <span className={style.cta}>
    <FiChevronRight />
    <Anchor href={to}>{children}</Anchor>
  </span>
)

export default CTA
